import React from 'react';
import * as css from './Operations.css';
import Btn from '../button/btn/Btn';
import List from '../list/List';
import useShow from '../../hooks/useShow';
import {Button} from '@tickchak/react-share/app';

function OperationButton({item, index, isNewButton}) {
    const listShow = item.listData ? useShow() : null;
    const handleClick = (e) => {
        if(item.listData) listShow?.open();
        else if(item.onClick) item.onClick(e);
    };

    const listData = item.listData && listShow && (
        <List list={item.listData} showClass={listShow.showClass} close={listShow.close} {...item.listConfig} />
    );

    if(isNewButton) {
        return (
            <React.Fragment>
                <Button
                    variant={item.variant}
                    size={item.size || 'chip'}
                    highlight={item.highlight}
                    iconStart={item.children || (!item.withoutPlus ? <css.plus>{'+'}</css.plus> : undefined)}
                    disabled={item.disabled}
                    onClick={handleClick}
                >
                    {item.text}
                </Button>
                {listData}
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Btn className={index%2!==0 && 'gray'} style={item.btnCss} onClick={handleClick}>
                {item.children ? item.children : !item.withoutPlus && <css.plus>{'+'}</css.plus>}
                {item.text}
            </Btn>
            {listData}
        </React.Fragment>
    );
}

export default OperationButton;
